var transformLogicalProperty = function transformLogicalProperty(properties) {
  return function (value) {
    return {
      base: properties.map(function (property) {
        return "".concat(property, ": ").concat(value, ";");
      }).join("")
    };
  };
};

export { transformLogicalProperty };
